<on-two-columns-display [title]="'company.category.title' | translate">
    <div
        description
        [innerHTML]="'company.category.description' | translate"
    ></div>

    <div content class="col align-items-center justify-content-center">
        <on-employee-categories-table
            #EmployeeCategoriesTab
            [companyId]="companyId"
        ></on-employee-categories-table>
    </div>
</on-two-columns-display>
